<template>
  <div id="priceFinder">
    <div class="row " style="margin-bottom: 60px;">
      <div class="col s12">
        <p class="fontSize30" style="color: #313131; margin: 0 0 10px 0;"> Preisfinder </p>
        <div class="row white" style="margin-bottom: 10px;">
          <div class="col s2 center">
            <img class="responsive-img" src="../assets/preisfinder.png" />
          </div>

          <div class="col s10" style="padding-left: 10px">
            <p class="fontSize18" style="margin-top: 0px; color: #313131">Bestimmen Sie den Marktpreis für Ihren Stapler. Wir ermitteln aus über 10 Millionen Preispunkten den aktuellen Marktpreis für ihr Fahrzeug. So sind Sie sicher, dass sie den optimalen Preis anbieten</p>
          </div>
        </div>
       
      </div>

      <div class="col s12">
        <div class="col s8" style="padding-left: 0px;">
          <p class="fontSize22" style="margin-top: 0px; margin-bottom: 0px; font-weight: bold; color: #313131">Marke und Typ</p>
          <div class="col s12" style="padding: 10px">
            <RadioToggleButtons
              v-model="currentBrand"
              :values="fixedBrands"
              color="grey"
              textColor="black"
              selectedTextColor="white"
            />
          </div>

          <!-- Brands -->
          <div class="col s12">
            <div class="input-field col s6" >
              <label class="active" for="currentBrand" style="font-weight: bold; color: #313131">Andere Marke</label>
              <input :disabled="disabled == 1"
                placeholder="Marke eingeben"
                autocomplete="off"
                id="currentBrand"
                type="text"
                v-model="currentBrand"
                @focus="modal = true"

                class="browser-default largeInputWidth col s6"
                style="margin-top: 5px; text-transform: capitalize;"
              />
            </div>

            <div v-if="currentBrand && filteredUniqueBrands && modal" class="col s12" style="padding-bottom: 10px; padding-left: 0px; margin-top: -15px">
              <div class="col s6">
                <div class="col s6 widthSearchBox" style="padding-left: 10px; border: 1px solid #313131; border-top: 0px solid #313131; border-radius: 5px; margin-left: 0px; min-width: 130px;">
                  <ul style="margin: 3px; overflow-y: auto; max-height: 100px; color: #313131">
                    <li 
                      v-for="filteredUniqueBrand in filteredUniqueBrands"
                      v-bind:key="filteredUniqueBrand"
                      @click="setCurrentBrand(filteredUniqueBrand)"
                    >
                      {{ filteredUniqueBrand }}
                      
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- <div v-if="currentBrand && filteredUniqueBrands && modal" class="col s12" style="padding-bottom: 10px; padding-left: 20px">
            <div class="col s2 widthSearchBox" style="padding-left: 10px; border: 1px solid #313131; border-radius: 10px;">
              <ul style="margin: 3px; overflow-y: auto; max-height: 100px; color: #313131">
                <li 
                  v-for="filteredUniqueBrand in filteredUniqueBrands"
                  v-bind:key="filteredUniqueBrand"
                  @click="setCurrentBrand(filteredUniqueBrand)"
                >
                  {{ filteredUniqueBrand }}
                  
                </li>
              </ul>
            </div>
          </div> -->
        
          <!-- Types -->
          <div class="col s12">
            <div class="input-field col s6">
              <label class="active" for="currentType" style="font-weight: bold; color: #313131">Typ</label>
              <input :disabled="disabled == 1"
                placeholder="Typ eingeben"
                autocomplete="off"
                id="currentType"
                type="text"
                v-model="currentType"
                @focus="typeModal = true"

                class="browser-default largeInputWidth col s6"
                style="margin-top: 5px;"
              />
            </div>

            <div v-if="currentType && filteredUniqueTypes && typeModal" class="col s12" style="padding-bottom: 10px; padding-left: 0px; margin-top: -15px">
              <div class="col s6">
                <div class="col s6 widthSearchBox" style="padding-left: 10px; border: 1px solid #313131; border-radius: 5px; margin-left: 0px; min-width: 130px;"> 
                  <ul style="margin: 3px; overflow-y: auto; max-height: 100px; color: #313131">
                    <li
                      v-for="filteredUniqueType in filteredUniqueTypes"
                      v-bind:key="filteredUniqueType"
                      @click="setCurrentType(filteredUniqueType)"
                    >
                      {{filteredUniqueType}}
                      
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>          
       
          <!-- <div v-if="currentType && filteredUniqueTypes && typeModal" class="col s12" style="padding-bottom: 10px; padding-left: 20px">
            <div class="col s4" style="padding-left: 10px; border: 1px solid #313131; border-radius: 10px;"> 
              <ul style="margin: 3px; overflow-y: auto; max-height: 100px; color: #313131">
                <li
                  v-for="filteredUniqueType in filteredUniqueTypes"
                  v-bind:key="filteredUniqueType"
                  @click="setCurrentType(filteredUniqueType)"
                >
                  {{filteredUniqueType}}
                  
                </li>
              </ul>
            </div>
          </div> -->

          <p class="fontSize22" style="margin-bottom: 5px; font-weight: bold; color: #313131">Technische Daten</p>
          
          <!-- Load Capacity -->   
          <div class="col s12">
           <div class="input-field col s6">
            <label class="active" for="loadCapacity" style="font-weight: bold; color: #313131">Tragkraft</label>
            <input
                disabled
                type="tel"
                placeholder="Kg"
                id="loadCapacity"
                v-model="loadCapacity"

                class="browser-default smallInputWidth col s4"
                style="margin-top: 5px; margin-right: 5px"
            /> <h6> kg </h6>
            </div>  
          </div>

          <div v-if="currentMast" class="col s12" style="padding-top: 5px" disabled>
            <div class="input-field col s12" style="padding: 6px 0 0 0">
              <label class="active" style="font-weight: bold; color: #313131">Mast</label>
              <p style="margin: 0px" class="height3px"></p>
              <RadioToggleButtons 
                v-model="currentMast"
                :values="allMasts"
                color="grey"
                textColor="black"
                selectedTextColor="white"
              />
            </div>
          </div>

          <!-- Construction Year -->
          <div class="col s12">
           <div class="input-field col s6">
              <label class="active" for="constructionYear" style="font-weight: bold; color: #313131">Baujahr</label>
              <input :disabled="disabled == 1"
                placeholder="YYYY"
                id="constructionYear"
                type="number"
                v-model="constructionYear"

                class="browser-default smallInputWidth col s4"
                style="margin-top: 5px;"
              />
            </div>
          </div>
          
          <div class="col s12">
            <div class="input-field col s6">
              <label class="active" for="operatingHours" style="font-weight: bold; color: #313131">Betriebsstunden</label>
              <input :disabled="disabled == 1"
                placeholder="hhhh"
                id="operatingHours"
                type="tel"
                v-model="operatingHours"

                class="browser-default smallInputWidth col s4"
                style="margin-top: 5px;"
              />
              
            </div>
          </div>

          <div v-if="findPriceBtnToggle" class="col s12 center" style="padding: 10px">
            <!-- <a class="btn white black-text" style="margin: 10px;" v-on:click="newInput">Neue Eingabe</a> -->
            <a class="btn" @click="disabled = disabled + 1" v-on:click="findPriceBtn" style="text-transform: none; background-color: #57B65B">
              Preis finden
              <i v-if="submitLoading" class="fa fa-spinner fa-spin"></i>
            </a>
          </div>
        </div>

        <div v-if="resultDivToggle" class="col s4 white">
          <p class="fontSize18" style="font-weight: bold">Ergebnis:</p>
          <p class="fontSize18">Der Marktpreis für den Stapler mit den von Ihnen übermittelten Daten</p>
          <p class="fontSize18" style="text-transform: capitalize;">
            Marke: {{ currentBrand }}
            <br />
            Typ: {{ currentType }}
            <br />
            Tragkraft: {{ loadCapacity }} kg
            <br />
            Baujahr: {{ constructionYear }}
            <br />
            Betriebsstunden: {{ operatingHours }}
          </p>
          
          <div class="col s4 fontSize18" style="padding-left: 0px">
            beträgt: {{ }} 
          </div>
          <div class="col s8 right-align" style="padding-right: 0px">
            <span class="fontSize18" style="font-weight: bold; text-decoration: underline;">{{ prediction }} Euro</span>
          </div>
          <!-- <p>beträgt: {{ }}</p> -->
          <!-- <p class="center">{{ prediction }} Euro.</p> -->
          <div class="col s12 right-align" style="padding: 50px 0 10px 0">
            <a class="btn-small z-depth-0" v-on:click="newInput" style="background-color: white; color: #6D6E71; border: 1px solid #6D6E71; text-transform: capitalize;"> <span class=""> Neue Eingabe </span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import fb from "../components/firebaseInit";
import db from "../DB/vehicle_cascading_properties.json";
export default {
  name: "priceFinder",
  data() {
    return {
      db,
      modal: false,
      typeModal: false,

      preisfinderToggle: null,

      submitLoading: false,

      currentBrand: "",
      fixedBrands: [
        { label: "Linde", value: "linde" },
        { label: "STILL", value: "still" },
        { label: "Jungheinrich", value: "jungheinrich" },
        { label: "Toyota", value: "toyota" },
        { label: "BT", value: "bt" },
        { label: "Hyster", value: "hyster" }
      ],
      allBrands: [],
      uniqueBrands: [],
      filteredUniqueBrands: [],

      currentType: null,
      allTypes: [],
      uniqueTypes: [],
      filteredUniqueTypes: [],

      loadCapacity: null,
      allLoadCapacity: [],

      currentMast: null,
      allMasts: [],

      constructionYear: null,
      currentYear: new Date().getFullYear(),
      vehicleAge: null,

      operatingHours: null,
      operatingHoursPerYear: null,

      currentClassification: null,

      prediction: null,

      resultDivToggle: false,
      findPriceBtnToggle: true,

      disabled: 0
    };
  },

  created() {
    const currentUserUID = firebase.auth().currentUser.uid;
    const currentUserDoc = fb.collection("user").doc(currentUserUID);

    currentUserDoc
      .get()
      .then(doc => {
        if (doc.exists) {
          this.preisfinderToggle = doc.data().preisfinder;
          if (this.preisfinderToggle == false) {
            this.$router.replace("/user");
          }
        } else {
          console.log("No such document!");
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });

    for (let i = 0; i < this.db.length; i++) {
      this.allBrands.push(this.db[i].hersteller);
    }

    this.uniqueBrands = [...new Set(this.allBrands)];

    this.filterUniqueBrands();
  },

  computed: {
        isIdle() {
            return this.$store.state.idleVue.isIdle;
        }
  },

  watch: {
    currentBrand() {
      this.filterUniqueBrands();

      (this.currentClassification = null), (this.currentType = "");
      (this.currentMast = null),
        this.loadCapacity = '',
        (this.vehicleAge = null),
        (this.operatingHours = null),
        (this.operatingHoursPerYear = null),
        (this.constructionYear = null),
        (this.prediction = null);

      this.allTypes = [];
      this.uniqueTypes = [];
      this.filteredUniqueTypes = [];

      for (let i = 0; i < this.db.length; i++) {
        if (this.db[i].hersteller == this.currentBrand) {
          this.allTypes.push(this.db[i].typ);
        }
      }

      this.uniqueTypes = [...new Set(this.allTypes)];
    },

    currentType() {
      this.filterUniqueTypes();

      (this.currentClassification = null),
        (this.currentMast = null),
        // this.loadCapacity = null,
        (this.vehicleAge = null),
        (this.operatingHours = null),
        (this.operatingHoursPerYear = null),
        (this.constructionYear = null),
        (this.prediction = null),
        (this.allLoadCapacity = []);
      this.allMasts = [];

      // Calculate Load Capacity
      for (let i = 0; i < this.db.length; i++) {
        if (
          this.db[i].hersteller == this.currentBrand &&
          this.db[i].typ == this.currentType
        ) {
          this.allLoadCapacity.push(this.db[i].tragkraft);
          this.loadCapacity = this.allLoadCapacity[0];
        }
      }
    },

    loadCapacity() {
      for (let i = 0; i < this.db.length; i++) {
        if (
          this.db[i].hersteller == this.currentBrand &&
          this.db[i].typ == this.currentType &&
          this.db[i].tragkraft == this.loadCapacity
        ) {
          this.allMasts.push({
            label: this.db[i].mast,
            value: this.db[i].mast
          });
        }
      }

      this.currentMast = this.allMasts[0].value;
    },

    isIdle() {
      if(this.$store.state.idleVue.isIdle == true){
        firebase.auth().signOut().then(() => {
            this.$router.replace("/");
            window.location.reload();
        },
        error => {
          console.log(error);
        });
      }
    }
  },

  methods: {
    filterUniqueBrands() {
      if (this.currentBrand.length == 0) {
        this.filteredUniqueBrands = [];
        // for(let i = 0; i < this.fixedBrands.length; i++) {
        //         this.filteredUniqueBrands.push(this.fixedBrands[i].label)
        // }
      } else {
        this.filteredUniqueBrands = this.uniqueBrands.filter(brand => {
          return brand
            .toLowerCase()
            .startsWith(this.currentBrand.toLowerCase());
        });
      }
    },

    setCurrentBrand(brand) {
      this.currentBrand = brand;
      this.modal = false;
    },

    filterUniqueTypes() {
      if (this.currentType.length == 0) {
        this.filteredUniqueTypes = [];
      } else {
        this.filteredUniqueTypes = this.uniqueTypes.filter(type => {
          var toStr = type.toString();
          return toStr.toLowerCase().startsWith(this.currentType.toLowerCase());
        });
      }
    },

    setCurrentType(type) {
      this.currentType = type;
      this.typeModal = false;
    },

    findPriceBtn() {
      this.submitLoading = true;

      this.resultDivToggle = true

      this.vehicleAge = this.currentYear - this.constructionYear;

      if (this.vehicleAge == 0) {
        this.operatingHoursPerYear = this.operatingHours;
      } else {
        this.operatingHoursPerYear = this.operatingHours / this.vehicleAge;
      }

      for (let i = 0; i < this.db.length; i++) {
        if (
          this.db[i].hersteller == this.currentBrand &&
          this.db[i].typ == this.currentType
        ) {
          this.currentClassification = this.db[i].classification;
        }
      }

      console.log(this.currentType, "type");
      console.log(this.currentBrand, "brand");

      console.log(this.currentMast, "mast");
      console.log(this.loadCapacity, "loadcapacity");
      console.log(this.constructionYear, "construction year");

      console.log(this.vehicleAge, "vehicleage");

      console.log(this.operatingHours, "op");
      console.log(this.operatingHoursPerYear, "op per year");

      console.log(this.currentClassification);

      let accessTokenURL =
        "https://us-central1-fmp20-260516.cloudfunctions.net/accessTokenResponse";
      Vue.axios.get(accessTokenURL).then(response => {
        const accessToken = response.data.access_token;

        // console.log(accessToken);

        let url =
          "https://ml.googleapis.com/v1/projects/fmp20-260516/models/priceprediction:predict?access_token=";
        let finalUrl = url + accessToken;

        Vue.axios
          .post(
            finalUrl,
            {
              instances: [
                [
                  this.currentClassification,
                  this.currentType,
                  this.currentBrand,
                  this.currentMast,
                  this.loadCapacity,
                  this.vehicleAge,
                  this.operatingHours,
                  this.operatingHoursPerYear
                ]
              ]
            },
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          )
          .then(response => {
            this.submitLoading = false;

            this.findPriceBtnToggle = false

            this.prediction = response.data.predictions[0].toFixed(2);
            this.prediction = this.prediction.replace(".", ",");
            this.prediction = this.prediction
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            this.prediction = this.prediction.slice(0, -3);

            this.loadCapacity = this.loadCapacity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.loadCapacity = this.loadCapacity.replace(",", ".");

            this.operatingHours = this.operatingHours.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.operatingHours = this.operatingHours.replace(",", ".");
          });
      });
    },

    newInput() {
      window.location.reload();
    }
  }
};
</script>